import { render } from "./TabletHeaderMenu.vue?vue&type=template&id=2012159c&scoped=true"
import script from "./TabletHeaderMenu.vue?vue&type=script&lang=js"
export * from "./TabletHeaderMenu.vue?vue&type=script&lang=js"

import "./TabletHeaderMenu.vue?vue&type=style&index=0&id=2012159c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2012159c"]])

export default __exports__